import { vuexQueryBase } from '@/store/compositionV2/utils/query'
import { vuexRouterBase } from '@/store/compositionV2/utils/router'
import { vuexDataBase } from '@/store/compositionV2/utils/data'
import { vuexLoadingBase } from '@/store/compositionV2/utils/loading'

const createState = () => ({
  ...vuexDataBase.createState(),
  ...vuexRouterBase.createState(),
  ...vuexQueryBase.createState(),
  ...vuexLoadingBase.createState()
})

const createGetters = () => ({
  ...vuexDataBase.createGetters(),
  ...vuexQueryBase.createGetters(),
  ...vuexLoadingBase.createGetters()
})

const createMutations = () => ({
  ...vuexDataBase.createMutations(),
  ...vuexQueryBase.createMutations(),
  ...vuexLoadingBase.createMutations()
})

const createActions = () => ({
  ...vuexDataBase.createActions(),
  ...vuexQueryBase.createActions(),
  ...vuexRouterBase.createActions()
})

export const vuexBase = {
  createState,
  createGetters,
  createMutations,
  createActions
}
